/* eslint-disable camelcase */
import { IChannel, IGif } from '@giphy/js-types'
import { SearchContext } from '@giphy/react-components'
import React, { useContext } from 'react'
import styled from 'styled-components'
import VerifiedBadge_ from './verified-badge'

const Container = styled.div`
    display: flex;
    align-items: center;
    font-family: interface, helvetica, arial;
    cursor: pointer;
`

const Username = styled.div`
    color: white;
    font-size: 13px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-font-smoothing: antialiased;
    :hover {
        color: rgba(255, 255, 255, 0.95);
    }
`
const VerifiedBadge = styled(VerifiedBadge_)`
    flex-shrink: 0;
`
type Props = { gif: IGif; className?: string }

// Duplicate of SDK attribution
// it shows username

const Attribution = ({ gif, className }: Props) => {
    const { user } = gif
    const { setActiveChannel } = useContext(SearchContext)
    if (!user?.username && !user?.display_name) {
        return null
    }
    const { username } = user
    return (
        <Container
            className={className}
            onClick={async (e) => {
                e.preventDefault()
                e.stopPropagation()
                const result = await fetch(
                    `https://api.giphy.com/v1/channels/search?q=${username}&offset=0&api_key=sXpGFDGZs0Dv1mmNFvYaGUvYwKX0PWIh`,
                )
                const { data } = (await result.json()) as { data: IChannel[] }
                setActiveChannel(data[0])
            }}
        >
            <Username>{`@${username}`}</Username>
            {user.is_verified ? <VerifiedBadge size={12} /> : null}
        </Container>
    )
}
export default Attribution
